export default __webpack_public_path__ + "static/media/hunt.c1f671a0.png";